import {Component, ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {promisifyModal} from 'common/components/modal/utils';

import {template} from './template';
import css from './index.inline.styl';

type TutorialVideoModalState = {
  isModalOpen: boolean;
};

export class TutorialVideoModal extends Component<TutorialVideoModalState, EmptyObj> {
  get config(): ConfigOptions<TutorialVideoModalState> {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        isModalOpen: true,
      },
      helpers: {
        closeModalHandler: () => {
          this.update({isModalOpen: false});
        },
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();

    // hide spinner when iframe loads
    const shadowRoot = document.getElementsByTagName(`mp-tutorial-video-modal`)[0].shadowRoot;
    const iframeEl = shadowRoot.getElementById(`tutorial-iframe`);
    const spinnerEl = shadowRoot.getElementById(`tutorial-spinner`);
    iframeEl.addEventListener(`load`, () => {
      spinnerEl.style.display = `none`;
    });
  }
}

export const TutorialVideoModalEl = defineAndMakeJsxFactory(`mp-tutorial-video-modal`, TutorialVideoModal);

export const TutorialVideoModalReact = panel2react(`mp-tutorial-video-modal`, TutorialVideoModal);

export const openMediaModal = (onErrorMessage: (ev: CustomEvent) => void) => {
  return promisifyModal({
    tagName: `mp-tutorial-video-modal`,
    attrs: {},
    closeEvents: [`error`],
    closeHandler: (ev) => {
      if (ev.type === `error`) {
        onErrorMessage(ev);
      }
    },
  });
};
